const __GLOBAL__ATC__FORM = (form) => {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    this.cart =  document.querySelector('cart-drawer');
    const formData = new FormData(form);
    
    if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
            this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        });
}

const __GLOBAL__ATC__CART_ITEMS = (items) => {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';
    this.cart =  document.querySelector('cart-drawer');

    var formData = {};
    formData.items = items;
    
    if (this.cart) {
        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }
              
      config.body = JSON.stringify(formData);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
            this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        });
}

class AddToCartSimple extends HTMLElement {
    constructor() {
      super();
    }
  
  connectedCallback() {
    this.submit = this.querySelector('form button[name="submit"]');
    console.warn(this.submit);
    this.submit.addEventListener('click', (e) => {
      e.preventDefault();

      this.submit.setAttribute('disabled', '');
      this.form = this.querySelector('form');

      __GLOBAL__ATC__FORM(this.form);      

      setTimeout(() => {
        this.submit.removeAttribute('disabled');
      }, 2000);
    });
  }
}

customElements.define('atc-simple', AddToCartSimple);




class Drawer extends HTMLElement {
  constructor() {
    super();
    this.animationDuration =
      this.getAttribute("data-animation-duration") || 400;

    if (typeof this.animationDuration == "string") {
      this.animationDuration = parseInt(this.animationDuration);
    }

    this.isSubDrawer = this.getAttribute("data-subddrawer");
    this.isInMovement = false;

    this.closeOnEscNamed = this.closeOnEsc.bind(this);
    this.closeOnBlurNamed = this.closeOnBlur.bind(this);

    this.blurNodeTypes = ["BODY", "CART-DRAWER", "DRA-WER"];
  }

  setDrawerTargets() {
    this.querySelectorAll("drawer-control").forEach((elem) => {
      if (!elem.hasAttribute("for")) {
        elem.setAttribute("for", this.getAttribute("id"));
      }
    });
  }

  closeOnBlur(event) {
    if (this.blurNodeTypes.includes(event.target.nodeName)) {
      this.closeDrawer();
    }
  }

  closeOnEsc(event) {
    if (event.keyCode == 27) {
      this.closeDrawer();
    }
  }

  bindWindowEvents() {
    window.addEventListener("keydown", this.closeOnEsc.bind(this));
    window.addEventListener("click", this.closeOnBlur.bind(this));
  }

  unbindWindowEvents() {
    window.removeEventListener("keydown", this.closeOnEsc.bind(this));
    window.removeEventListener("click", this.closeOnBlur.bind(this));
  }

  isMoving() {
    this.isInMovement = true;
    this.setAttribute("is-moving", "");

    setTimeout(() => {
      this.removeAttribute("is-moving");
      this.isInMovement = false;
    }, this.animationDuration);
  }

  closeDrawer() {
    this.isMoving();
    this.removeAttribute("open");

    if (!this.isSubDrawer) {
      this.unbindWindowEvents();

      if (document.querySelector('dra-wer[open]')) { return; }
      document.body.classList.remove("fade-body");
    }
  }

  openDrawer() {
    this.isMoving();
    this.setAttribute("open", "");

    if (!this.isSubDrawer) {
      this.bindWindowEvents();
      document.body.classList.add("fade-body");
    }
  }

  addAnimationClass() {
    if (!this.classList.contains("allow-modal-transition")) {
      this.classList.add("allow-modal-transition");
    }
  }

  connectedCallback() {
    this.addAnimationClass();
    this.setDrawerTargets();
  }
}

class DrawerControl extends HTMLElement {
  constructor() {
    super();

    this.action = this.getAttribute("action") || "close";
    this.drawerTarget = document.querySelector("#" + this.getAttribute("for"));

    if (!this.drawerTarget) {
      this.drawerTarget = this.closest('dra-wer');
    }
  }

  onInteraction() {
    if (this.action == "close") {
          this.drawerTarget = document.querySelector("#" + this.getAttribute("for"));

    if (!this.drawerTarget) {
      this.drawerTarget = this.closest('dra-wer');
    }
      this.drawerTarget.closeDrawer();
    }
    if (this.action == "open") {
          this.drawerTarget = document.querySelector("#" + this.getAttribute("for"));

    if (!this.drawerTarget) {
      this.drawerTarget = this.closest('dra-wer');
    }
      this.drawerTarget.openDrawer();
    }
  }

  listenForInteraction() {
    this.addEventListener("click", this.onInteraction);
  }

  connectedCallback() {
    this.listenForInteraction();
  }
}

customElements.define("dra-wer", Drawer);
customElements.define("drawer-control", DrawerControl);
